const navLinks = [
    { path: '/', label: 'costa_news' },
    { path: '/gallery', label: 'media_gallery' },
    { path: '/contacts', label: 'contacts' },
];

export default navLinks;
